import { mostDiscussed } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function MostDiscussed() {
  return (
    <section id="most-discussed" className="w-full px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        kicker="Most Discussed"
        title="讨论最多 · 评论区才是主战场"
        desc="点击可以靠标题，讨论只能靠真话题。这里按评论数倒序，越往上吵得越凶。"
      />

      <div className="mt-10 border-t border-background-200">
        {mostDiscussed.map((item) => (
          <article
            key={item.rank}
            className="group flex items-center gap-4 border-b border-background-200 py-4 transition-colors hover:bg-background-100 md:gap-6 md:py-5"
          >
            <span className="w-8 shrink-0 text-center font-label text-2xl font-semibold text-foreground-300 md:w-10 md:text-3xl">
              {item.rank}
            </span>
            <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-20 md:w-20">
              <img
                src={item.image}
                alt={item.title}
                title={`讨论最多 - ${item.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                <a href="#top-ranking">{item.title}</a>
              </h3>
              <span className="mt-2 inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900 md:text-xs">
                {item.tag}
              </span>
            </div>
            <div className="flex shrink-0 items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-accent-900">
              <i className="ri-chat-3-fill text-sm" />
              <span className="font-label text-sm font-semibold">{item.comments}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}